import { Link } from "gatsby"
import React, { ReactElement } from "react"
import MediaQuery, { useMediaQuery } from "react-responsive"
import * as config from "../../config"
import * as styles from "./header.module.scss"

const logoPath = "/QT-net.webp"

export const Header = (): ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: config.RESPONSIVE_BREAKPOINT })

  return (
    <header className={styles.header}>
      <div className={styles.row}>
        <Link to="/" className={styles.logo}>
          <img
            src={logoPath}
            alt="logo"
            width={isMobile ? 48 : 77}
            height={isMobile ? 20 : 32}
          />
        </Link>
        <MediaQuery minWidth={config.RESPONSIVE_BREAKPOINT}>
          <p className={styles.title}>駐車場検索</p>
        </MediaQuery>
      </div>
      <MediaQuery maxWidth={config.RESPONSIVE_BREAKPOINT}>
        <div className={styles.bottomBorder} />
      </MediaQuery>
    </header>
  )
}
